"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const _dayjs = /*#__PURE__*/ _interopRequireDefault(require("dayjs"));
require("dayjs/locale/id");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Generate date string with specified format and date
 *
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */ _dayjs.default.locale("id");
const formatDate = (date, format)=>{
    if (format === void 0) format = "DD MMMM YYYY";
    return (0, _dayjs.default)(date).format(format);
};
const _default = formatDate;
